/**
 * MLB headshot URL helper. The `midfield.mlbstatic.com` endpoint serves
 * the player headshot keyed by personId. No auth, no rate limits at our
 * scale. 120px is the default rendered size on the field; 240 / 480 are
 * used for the rosters cards and the modal.
 *
 * Returns null when personId is missing/zero so callers can render the
 * silo silhouette without a network request that always 404s.
 */
const VALID_SIZES = [56, 60, 90, 120, 180, 240, 360, 480] as const;
export type HeadshotSize = (typeof VALID_SIZES)[number];

const BASE = 'https://midfield.mlbstatic.com/v1/people';

export function headshotUrl(
  personId: number | null | undefined,
  size: HeadshotSize = 120,
): string | null {
  if (!personId || personId <= 0) return null;
  return `${BASE}/${personId}/spots/${size}`;
}
